import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { PopoverService } from 'src/@vex/components/popover/popover.service';
import { map, startWith, switchMap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { CandidateService } from 'src/app/services/candidate-service.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { ImportPasswordsComponent } from '../import-passwords/import-passwords.component';
@Injectable({
  providedIn: 'root'
})
export class CandidateOperationService {
  opOpen$: Observable<boolean> = of(false);
  constructor(private snackBar: SnackbarService, private candidateServices: CandidateService, private router: Router, private popoverService: PopoverService,) { }


  async processCandidateOperation(route: any, origin: any) {

    if (route == 'candidate/reset-password') {
      this.resetPassword();
    }
    if (route == 'operations/candidate/schedule') {
      this.router.navigate(['exams/0/schedules/0'], {
        queryParams: { mode: 'add', isFromCandidate: true }
      });
    }
    if (route == 'operations/candidate/import-password') {
      this.openPopup(origin, ImportPasswordsComponent);
    }
    // if (route == 'operations/exam/pausestatus') {
    //   this.openExamPause(origin);
    // }
    // if (route == 'operations/exam/generatedps') {
    //   this.openGenerateDps(origin);
    // }
    // if (route == 'operations/exam/questions/preload') {
    //   this.openPreLoad(origin);
    // }
    // if (route == 'operations/exam/test') {
    //   this.openQtest(origin);
    // }
    // if (route == 'operations/exam/questions/export') {
    //   this.openQExport(origin);
    // }

    // if (route == 'operations/exam/questions') {
    //   this.router.navigate(['exam/questions'])
    // }
  }

  resetPassword() {
    let data = this.candidateServices.selectedCandidates?.[0];
    this.candidateServices.resetCandidatePassword(data).then(s => {
      this.snackBar.success('Password Reset successfull');
    });
  }

  public operationCandidateList() {
    return [
      {
        icon: 'mat:cloud_upload',
        label: 'Reset Password',
        route: 'candidate/reset-password',
        id: 'reset_password'
      },
      {
        icon: 'mat:calendar_today',
        label: 'Schedule Candidate',
        route: 'operations/candidate/schedule',
        id: 'examinations_examination_schedules'
      },
      {
        icon: 'mat:file_copy',
        label: 'Import Passwords From Excel',
        route: 'operations/candidate/import-password',
        id: 'import_passwords_frome_excel'
      },
      //   {
      //     icon: 'mat:calendar_today',
      //     label: 'Schedule Candidates',
      //     route: 'operations/exam/apps/contacts/grid'
      //   },
      //   {
      //     icon: 'mat:file_copy',
      //     label: 'Copy Exam Questions',
      //     route: 'operations/exam/questions/copy'
      //   },
      //   {
      //     icon: 'mat:import_export',
      //     label: 'Export Exam Questions',
      //     route: 'operations/exam/questions/export'
      //   },
      //   {
      //     icon: 'mat:pause',
      //     label: 'Pause/Un-Pause Exam',
      //     route: 'operations/exam/pausestatus'
      //   },
      //   {
      //     icon: 'mat:speaker_notes',
      //     label: 'Test Questions',
      //     route: 'operations/exam/test'
      //   },
      //   {
      //     icon: 'mat:web_asset',
      //     label: 'Generate Registration URL',
      //     route: 'operations/exam/exams/examurl'
      //   },
      //   {
      //     icon: 'mat:brightness_auto',
      //     label: 'Auto-generate Proctor Schedule',
      //     route: 'operations/exam/generatedps'
      //   }
    ];
  }
  openPopup(origin: any, component: any) {
    this.opOpen$ = of(
      this.popoverService.open({
        content: component,
        origin,
        width: 2000,
        offsetY: 12,
        position: [
          {
            originX: 'end',
            originY: 'center',
            overlayX: 'end',
            overlayY: 'center'
          }, {
            originX: 'end',
            originY: 'center',
            overlayX: 'end',
            overlayY: 'center'
          }
        ]
      })
    ).pipe(
      switchMap(popoverRef => popoverRef.afterClosed$.pipe(map((x) => false))),
      startWith(true),
    );
  }
}
